import { environment } from '../../environments/environment';

/**
 * Brand from hostname (shared FORM build on EC2 serves both hosts).
 * - *gaponline* → classic GAP
 * - *gwarancjeonline* → WAR
 * - localhost / unknown → environment.classicGap fallback
 */
export function isClassicGapHost(
  hostname: string = typeof location !== 'undefined' ? location.hostname : '',
): boolean {
  if (hostname.includes('gwarancjeonline')) {
    return false;
  }
  if (hostname.includes('gaponline')) {
    return true;
  }
  return environment.classicGap;
}
